import React from 'react';

function NoticesEditor({ pageContent, uploading, uploadingField, addTableRow, deleteTableRow, updateTableRow, handleRowImageUpload }) {
  return (
    <div className="page-editor">
      <div className="editor-card">
        <h3>📢 All Notices</h3>
        {(pageContent.notices || []).map((n) => (
          <div key={n.id} style={{border:'1px solid #e2e8f0',padding:12,marginBottom:10}}>
            <input placeholder="Title" value={n.title || ''} onChange={(e) => updateTableRow('notices', n.id, 'title', e.target.value)} className="form-input" />
            <textarea placeholder="Content" value={n.content || ''} onChange={(e) => updateTableRow('notices', n.id, 'content', e.target.value)} rows="2" className="form-input" />
            <input type="date" value={n.date || ''} onChange={(e) => updateTableRow('notices', n.id, 'date', e.target.value)} className="form-input" />
            <div className="form-group">
              <label>Notice Image</label>
              {n.image && <img src={n.image} className="preview-img-sm" />}
              <label className="upload-label">{uploading && uploadingField === `notices_${n.id}_image` ? '⏳...' : '📷 Image'}<input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleRowImageUpload('notices', n.id, 'image', e.target.files[0]); }} /></label>
            </div>
            <label><input type="checkbox" checked={!!n.isOld} onChange={(e) => updateTableRow('notices', n.id, 'isOld', e.target.checked)} /> Archive</label>
            <button className="remove-btn" onClick={() => deleteTableRow('notices', n.id)}>🗑️</button>
          </div>
        ))}
        <button className="add-btn" onClick={() => addTableRow('notices', { title: '', content: '', date: new Date().toISOString().split('T')[0], isOld: false, image: '' })}>+ Add Notice</button>
      </div>
    </div>
  );
}

export default NoticesEditor;